import React from 'react';
import PrimaryButton from '../PrimaryButton';
import TextButton from '../TextButton';
import Modal, {ModalWidth} from './Modal';
import ModalContent from './ModalContent';
import ModalButtons from './ModalButtons';

type Props = {
  title?: string
  actionBtnTitle: string
  show: boolean
  onConfirm: (e: React.MouseEvent) => void
  onClose: () => void
  closeBtnTitle?: string
  width?: ModalWidth
}

export default function Dialog({
  title, actionBtnTitle, show, onConfirm, onClose, width, children, closeBtnTitle,
}: React.PropsWithChildren<Props>) {
  return (
    <>
      <Modal title={title} show={show} onClose={onClose} width={width}>
        <ModalContent>
          {children}
        </ModalContent>
        <ModalButtons>
          <PrimaryButton onClick={onConfirm}>{actionBtnTitle}</PrimaryButton>
          {closeBtnTitle &&
          <TextButton onClick={onClose}>{closeBtnTitle}</TextButton>
          }
        </ModalButtons>
      </Modal>
    </>
  );
}
